export const gray = "#888680";
export const red = "#F15B59";
export const white = "#FFFFFF";
export const darkDenium = "#403C6F";
export const black = "#6B6862";
export const darkDenium25 = "#CFCEDA";
export const valueBlack = "#1B2F3F";
export const darkDenium75 = "#6E6D92";
export const black900 = "#0E0D09";

export const successBg = "#E8F5E9";
export const successText = "#1B5E20";
export const successBorder = "#1B5E20";

export const lowBg = "#FEF4E6";
export const lowText = "#7A3E00";
export const lowBorder = "#A85600";

export const placeholderText = "#5A5875";

export const darkBackground = "#080A0E";
export const buttonHoverDenium = "#2A254D";
export const linkHoverColor = "#322E59";
export const buttonPrimaryBg = "#3D3769";
export const successGreen = "#45B184";
export const linkColor = "#4B3F72";
export const textGray = "#4B5563";
export const purpleLight = "#9272D0";
export const textGrayLight = "#9CA3AF";
export const dangerRedDark = "#B83260";
export const borderLightBlue = "#E0E0EE";
export const borderGray = "#E5E7EB";
export const errorRed = "#E73232";
export const incompleteRed = "#E77877";
export const borderGrayLight = "#E8E8E9";
export const bgGrayLight = "#ECECF1";
export const warningOrange = "#EF8C3B";
export const bgGrayLighter = "#F3F4F6";
export const bgLightSky = "#F7F8FB";
export const selectedBlue = "#1976D2";
export const rangeBlue = "#E3F2FD";
export const vibrantPurple = "#635BFF";
